import { Button } from '@hud/web-components/Button/Button';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import MenuButton from '@hud/web-components/Menu/MenuButton';
import { themeColor } from '@hud/web-components/theme/colors';
import styled from 'styled-components';

export const FiltersIcon = styled(HudIcon)`
  color: ${themeColor('textTertiary')};
`;
export const FiltersMenuButton = styled(MenuButton)`
  min-width: 36px;
  justify-content: center;
`;

export const ClearAllButton = styled(Button)`
  border: none;
  background: none;
  color: ${themeColor('gray')};
  padding: 0;

  &:hover {
    color: ${themeColor('textPrimary')};
    background: none;
  }
`;
